import React, { useState, useEffect } from 'react'
import gameActions from '../../../store/actions/gameActions'
import { useDispatch, useSelector } from 'react-redux'
import Loading from '../../Loading'
import narrativesObject from '../../../narratives/narrativesObject'
import Button from '../../Button'

const Quizz = ({ quizz }) => {
    const [triviaState, setTriviaState] = useState({
        ready: false,
        allQuestions: narrativesObject[`${quizz}`],
        question: '',
        objectQuestion: [],
        questionNumber: 0,
        randomQuestions: [],
        currentAnswers: undefined,
        currentAnswersRandomize: false,
        totalCorrectAnswers: 0,
        totalIncorrectAnswers: 0,
        didAnswer: false
    })

    useEffect(() => {
        const getQuestions = printQuestionsAnswers('questions', currentQuizz.length)
        setTriviaState({ ...triviaState, ready: true, randomQuestions: getQuestions, objectQuestion: currentQuizz[getQuestions[0]] })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const dispatch = useDispatch()
    const currentQuizz = useSelector(state => state.game.currentNarrativeObject.minigames.quizzes[`${quizz}`])

    const printQuestionsAnswers = (type, iterations) => {
        var repeated;
        var arrayInput = [];
        for (let i = 0; i < iterations; i++) {
            if (arrayInput.length === 0) {
                arrayInput.push(type === 'questions' ? Math.floor(Math.random() * currentQuizz.length) : Math.floor((Math.random() * iterations)) - 1)
            } else {
                do {
                    repeated = 0;
                    var number = type === 'questions' ?
                        Math.floor(Math.random() * currentQuizz.length) : Math.floor((Math.random() * iterations)) - 1;
                    for (let x = 0; x < arrayInput.length; x++) {
                        number === arrayInput[x] && repeated++;
                    }
                } while (repeated !== 0) arrayInput.push(number);
            }
        }
        return arrayInput;
    }

    const randomizeAnswers = () => {
        const getAnswers = printQuestionsAnswers('answers', 4)
        var answersArray = [];
        for (var x = 0; x < getAnswers.length; x++) {
            if (getAnswers[x] === -1) {
                answersArray.push({ answer: triviaState.objectQuestion.correct_answer, res: 'correct' })
            } else {
                answersArray.push({ answer: triviaState.objectQuestion.incorrect_answers[getAnswers[x]], res: 'incorrect' })
            }
        }
        setTriviaState({
            ...triviaState, question: triviaState.objectQuestion.question, currentAnswers: answersArray, currentAnswersRandomize: true
        })
    }

    const handleAnswer = (answer) => {
        setTriviaState({
            ...triviaState,
            didAnswer: true
        })

        var changeQuestion = triviaState.questionNumber + 1

        if (answer) {
            triviaState.totalCorrectAnswers += 1
        } else {
            triviaState.totalIncorrectAnswers += 1
        }

        setTimeout(() => {
            if (triviaState.questionNumber === currentQuizz.length - 1) {
                dispatch(gameActions.unlockAdvancedNarrative('quizz'))
            }
            setTriviaState({
                ...triviaState,
                objectQuestion: currentQuizz[triviaState.randomQuestions[changeQuestion]],
                questionNumber: changeQuestion,
                currentAnswersRandomize: false,
                didAnswer: false
            })
        }, 4000)
    }

    const { objectQuestion, question, questionNumber, ready, currentAnswers, didAnswer, currentAnswersRandomize, totalCorrectAnswers, totalIncorrectAnswers } = triviaState;
    const disabledBtn = didAnswer ? true : false;

    if (!ready) {
        return <Loading />
    } else {
        if ((currentAnswersRandomize === false) && (objectQuestion !== undefined)) {
            randomizeAnswers()
            return <Loading />
        } else {
            if ((currentAnswersRandomize === true) && (objectQuestion !== undefined)) {
                return (
                    <div className='flex flex-col justify-center flex-wrap lg:max-w-2xl mx-auto'>
                        <h4 className='pb-0'>Quiz</h4>
                        <p className='pb-4'>Complete todo o quiz para conseguir avançar!</p>
                        <h3>{questionNumber + 1} - {question}</h3>
                        {currentAnswers.map((index, key) =>
                            index.res === 'correct' ?
                                <Button
                                    key={key}
                                    disabled={disabledBtn}
                                    onClick={() => { handleAnswer(true) }}
                                    className={`minigameButton my-3 w-full ${disabledBtn && "btn-success"}`}
                                >
                                    {index.answer}
                                </Button>
                                :
                                <Button
                                    key={key}
                                    disabled={disabledBtn}
                                    onClick={() => { handleAnswer(false) }}
                                    className={`minigameButton my-3 w-full ${disabledBtn && "btn-error"}`}
                                >
                                    {index.answer}
                                </Button>
                        )}
                    </div>
                )
            } else {
                return (
                    <div className='flex flex-col justify-center items-center'>
                        <h3 className='w-full text-center'>Resultados do Quiz</h3>
                        <div className='grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 md:gap-8 lg:gap-12 justify-center text-center'>
                            <div className='py-2 py-md-0'>
                                <p className='w-full text-success'>
                                    Respostas corretas: <b>{totalCorrectAnswers}</b>
                                </p>
                            </div>
                            <div className='py-2 py-md-0'>
                                <p className='w-full text-danger'>
                                    Respostas incorretas: <b>{totalIncorrectAnswers}</b>
                                </p>
                            </div>
                        </div>
                    </div>
                )
            }
        }
    }
}

export default Quizz